import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import dayjs from 'lib/dayjs';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysReOpenConversationMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();
  const { sysReOpenConversationContent } = raw;

  return sysReOpenConversationContent ? (
    <SystemMessage>
      {dayjs(Number(sysReOpenConversationContent.timestamp)).format('YYYY-MM-DD HH:mm')}
      {` [${sysReOpenConversationContent.assistantName}] `}
      {t('scene.chatWorkspace.currentConversation.action.reopenConversation')}
    </SystemMessage>
  ) : null;
});
